import { createTheme } from '@material-ui/core/styles';
import { fontStack } from './fonts';

// Dimora palette. Kept in sync with the CSS custom properties in globals.css so
// the Material-UI widgets (pickers, buttons, inputs) match the Tailwind/shadcn ones.
const bodyColor = '#F6F7F9';
const surfaceColor = '#FFFFFF';
const raisedColor = '#FFFFFF';
const borderColor = '#E3E8EE';
const primaryColor = '#0369A1';
const primaryDarkColor = '#075985';
const textColor = '#1C2733';
const mutedTextColor = '#5B6B7C';
const successColor = '#047857';
const warningColor = '#B45309';
const errorColor = '#B91C1C';
const onAccentColor = '#FFFFFF';

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: primaryColor,
      dark: primaryDarkColor,
      contrastText: onAccentColor
    },
    secondary: {
      main: primaryDarkColor,
      contrastText: onAccentColor
    },
    success: {
      main: successColor,
      contrastText: onAccentColor
    },
    warning: {
      main: warningColor,
      contrastText: onAccentColor
    },
    error: {
      main: errorColor,
      contrastText: onAccentColor
    },
    text: {
      primary: textColor,
      secondary: mutedTextColor
    },
    divider: borderColor,
    background: {
      paper: surfaceColor,
      default: bodyColor
    }
  },
  typography: {
    fontFamily: fontStack,
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0
    }
  },
  shape: {
    borderRadius: 14
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          fontFamily: fontStack
        },
        body: {
          fontFamily: fontStack,
          backgroundColor: bodyColor,
          color: textColor
        }
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: 14
      },
      elevation1: {
        backgroundColor: raisedColor,
        boxShadow: '0 1px 2px rgba(28, 39, 51, 0.06), 0 1px 3px rgba(28, 39, 51, 0.1)'
      }
    },
    MuiAppBar: {
      colorPrimary: {
        color: textColor,
        backgroundColor: surfaceColor
      }
    },
    MuiInputAdornment: {
      root: {
        color: mutedTextColor
      }
    },
    MuiButton: {
      root: {
        color: textColor,
        borderRadius: 12,
        paddingTop: 10,
        paddingBottom: 10
      },
      containedPrimary: {
        color: onAccentColor,
        backgroundColor: primaryColor,
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: primaryDarkColor,
          boxShadow: 'none'
        },
        '&.Mui-selected': {
          backgroundColor: primaryColor
        }
      }
    },
    MuiInput: {
      root: {
        color: textColor
      },
      underline: {
        '&:before': {
          borderBottomColor: borderColor
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottomColor: primaryColor
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 12
      }
    },
    MuiFormLabel: {
      root: {
        color: mutedTextColor
      }
    },
    MuiStepIcon: {
      root: {
        color: borderColor,
        '&$active': {
          color: primaryColor
        },
        '&$completed': {
          color: successColor
        }
      }
    },
    MuiTabs: {
      indicator: {
        backgroundColor: primaryColor
      }
    }
  }
});

export default theme;
